import { Redirect } from 'expo-router'

/** @deprecated just use `src/app/main/(tabs)/rewards/points-transfer.tsx` because it looks prettier in the url bar. i'm just keeping this around in case any deeplinks out in the wild depend on it */
export default function LegacyPointsTransferInterstitial() {
  return <Redirect href="/main/rewards/points-transfer" withAnchor />
}
